<script>

    import { toast } from 'bulma-toast'
    import { shipmentStore, chargesStore } from '../stores'

    import ChargesService from '../$services/charges.service'
    import DateMethod from '../$methods/date.method'

    import ChargeComponent from './component.charge.svelte'
    import TableCollapse from '../$components/table.collapse.svelte'

    $: $chargesStore & mapRows()

    let tableRows = []
    let expanded = null
    let loading = false

    getChargesShipment()

    async function getChargesShipment() {

        loading = true
        const resp = await ChargesService.getChargesShipment($shipmentStore._id)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        chargesStore.set(resp.data)
        mapRows()
    }

    function mapRows() {
        expanded = null
        tableRows = $chargesStore.map((charge, index) => {
            return [
                index+1,
                charge.status,
                charge.concept,
                charge.type,
                `$${charge.amount}`,
                DateMethod.dateTimeLarge(charge.created),
                {
                    component: ChargeComponent,
                    props: {charge}
                }
            ]
        })
    }

</script>

<TableCollapse bind:expanded
    inModal={true}
    headers={['', 'Estatus', 'Concepto', 'Tipo', 'Monto', 'Fecha']}
    rows={tableRows} 
    items={$chargesStore.length}
    {loading}
/>